/* ===========================================================
   TORRE ARKA BUYLIST
   Animaciones + FAQ + compatibilidad con editor de Shopify
=========================================================== */

(() => {
  const SECTION_SELECTOR = '[data-ta-buylist]';

  /**
   * Inicializa una sección Buylist.
   * Evita registrar eventos duplicados cuando Shopify
   * vuelve a cargar la sección dentro del editor visual.
   */
  function initializeBuylist(section) {
    if (!section) return;

    if (section.dataset.taBuylistInitialized === 'true') {
      return;
    }

    section.dataset.taBuylistInitialized = 'true';

    initializeRevealAnimations(section);
    initializeFaqAccordion(section);
    initializeSmoothScroll(section);
  }

  /**
   * Agrega las animaciones de aparición.
   */
  function initializeRevealAnimations(section) {
    const revealElements = section.querySelectorAll(
      [
        '.ta-buylist__benefit',
        '.ta-buylist__step',
        '.ta-buylist__list-card',
        '.ta-buylist__calculator',
        '.ta-buylist__factor',
        '.ta-buylist__faq',
        '.ta-buylist__legal',
        '.ta-buylist__final'
      ].join(',')
    );

    if (!revealElements.length) return;

    revealElements.forEach((element) => {
      element.setAttribute('data-ta-reveal', '');
    });

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      revealElements.forEach((element) => {
        element.classList.add('is-visible');
      });

      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    revealElements.forEach((element) => {
      observer.observe(element);
    });
  }

  /**
   * Convierte el FAQ en acordeón:
   * cuando se abre una pregunta, las demás se cierran.
   */
  function initializeFaqAccordion(section) {
    const faqItems = Array.from(
      section.querySelectorAll('.ta-buylist__faq')
    );

    if (!faqItems.length) return;

    faqItems.forEach((faqItem) => {
      faqItem.addEventListener('toggle', () => {
        if (!faqItem.open) return;

        faqItems.forEach((otherItem) => {
          if (otherItem !== faqItem && otherItem.open) {
            otherItem.removeAttribute('open');
          }
        });
      });
    });
  }

  /**
   * Desplazamiento suave para botones internos,
   * por ejemplo el botón "¿Cómo funciona?".
   */
  function initializeSmoothScroll(section) {
    const internalLinks = section.querySelectorAll(
      'a[href^="#"]'
    );

    if (!internalLinks.length) return;

    internalLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href');

        if (!targetId || targetId === '#') return;

        let target;

        try {
          target = document.querySelector(targetId);
        } catch (error) {
          return;
        }

        if (!target) return;

        event.preventDefault();

        const prefersReducedMotion = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

        target.scrollIntoView({
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });
  }

  /**
   * Busca e inicializa todas las secciones presentes.
   */
  function initializeAllBuylistSections(root = document) {
    const sections = root.querySelectorAll(SECTION_SELECTOR);

    sections.forEach((section) => {
      initializeBuylist(section);
    });
  }

  /**
   * Carga normal de la tienda.
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeAllBuylistSections();
    });
  } else {
    initializeAllBuylistSections();
  }

  /**
   * Compatibilidad con el editor visual de Shopify.
   */
  document.addEventListener('shopify:section:load', (event) => {
    const loadedSection = event.target.querySelector(SECTION_SELECTOR);

    if (loadedSection) {
      initializeBuylist(loadedSection);
      return;
    }

    if (event.target.matches?.(SECTION_SELECTOR)) {
      initializeBuylist(event.target);
    }
  });

  /**
   * Cuando Shopify selecciona un bloque dentro del editor,
   * asegura que sea visible.
   */
  document.addEventListener('shopify:block:select', (event) => {
    const selectedBlock = event.target;

    if (!selectedBlock) return;

    const parentSection = selectedBlock.closest(SECTION_SELECTOR);

    if (!parentSection) return;

    selectedBlock.classList.add('is-visible');
  });
})();
